import { visualStepSchema } from 'src/features/programsV2/schemas/visualStepSchema';

import { Program, ProgramFeatureName } from '../../../types/program';
import { formatVisualStepValues } from './formatVisualStepValues';

export const verifyCompletedVisualStep = async (program?: Program | null) => {
  if (!program) return false;

  const formattedValues = formatVisualStepValues(program);
  const selectedGenders = program.features.find(
    feature => feature.name === ProgramFeatureName.Gender
  );

  try {
    await visualStepSchema.validate(formattedValues, {
      abortEarly: false,
      context: { gender: selectedGenders?.value },
    });
    return true;
  } catch (error) {
    return false;
  }
};
